export enum CreateViewModifyV2Action {
  CREATE,
  VIEW,
  MODIFY
}
